var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 text-center p-a-sm text-muted"},[_c('i',{staticClass:"fa fa-spinner fa-spin fa-2x fa-fw"}),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])])])}]
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61638322","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/LoadingSpinner.vue
// module id = jd/D
// module chunks = 99